module.exports = __webpack_public_path__ + "img/140.1.16690512.jpg";